import { render, staticRenderFns } from "./FormsSectionBuilder.vue?vue&type=template&id=3dbeaa5e&scoped=true&lang=html&"
import script from "./FormsSectionBuilder.vue?vue&type=script&lang=js&"
export * from "./FormsSectionBuilder.vue?vue&type=script&lang=js&"
import style0 from "./FormsSectionBuilder.vue?vue&type=style&index=0&id=3dbeaa5e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dbeaa5e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VContainer,VDivider,VExpansionPanel,VExpansionPanelContent,VExpansionPanels,VFlex,VIcon,VLayout,VSpacer})
